// extracted by mini-css-extract-plugin
export var addToCartButton = "_o4-b";
export var arrowButtonContainer = "_o4-9";
export var arrowButtonIcon = "_o4-a";
export var carouselArrowButton = "_o4-6";
export var carouselElementContainer = "_o4-1";
export var left = "_o4-7";
export var productDisplayCarouselContainer = "_o4-0";
export var productTileContainer = "_o4-2";
export var productTileImage = "_o4-4";
export var productTileImageContainer = "_o4-3";
export var productTileTitle = "_o4-5";
export var right = "_o4-8";
export var sliderOverflow = "_o4-c";